import React, { InputHTMLAttributes } from 'react'
import styled from 'styled-components'

const SInput = styled.input`
  display: block;
  width: 100%;
  border-radius: 12px;
  font-size: ${(props) => props.theme.typography.inputFontSize};
  color: ${(props) => props.theme.colors.input};
  padding: 6px 12px;
  line-height: 28px;
  border: none;
  
  &:focus {
    outline: none;
  }

  &::placeholder {
    color: ${(props) => props.theme.colors.input};
  }

  &:disabled {
    background-color: white;
    opacity: 0.5;
  }
`

const Input: React.FC<InputHTMLAttributes<HTMLInputElement>> = (props) => {
  return <SInput {...props} />
}

export default Input